<template>
   <div class="cookie-alert__container" :style="{ display: isHidden ? 'none' : 'flex' }">
      <div class="cookie-alert__content">
         <div>{{ $t('cookies.alert') }}</div>
         <el-button type="primary" @click="onAcceptCookies">{{ $t('cookies.accept') }}</el-button>
         <router-link to="/privacy">{{ $t('cookies.more') }}</router-link>
      </div>
   </div>
</template>

<script>
import { getCookie, setCookie } from 'tiny-cookie'

export default {
   name: 'CookieAlert',
   data() {
      return {
         isHidden: getCookie('EU_COOKIE') !== null
      }
   },
   methods: {
      onAcceptCookies() {
         setCookie('EU_COOKIE', 'accepted')
         this.isHidden = true
      }
   }
}
</script>

<style lang="scss" scoped>
@import "../../sass/var";

.cookie-alert__container {
   background: white;
   display: flex;
   align-items: center;
   justify-content: center;
   border-top: 1px solid black;
   box-shadow: $--box-shadow-light;

   .cookie-alert__content {
      display: flex;
      align-items: center;
      & > * {
         margin: 0 8px;
      }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/app/CookieAlert.vue